module.exports = __webpack_public_path__ + "static/img/xq.34dac1fa.svg";